export default __webpack_public_path__ + "static/media/landing-block-je.c436ab79.svg";